document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.faq-item').forEach(item => {
    const button = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (!button || !answer) return;

    button.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      // Cerrar los demás (opcional)
      document.querySelectorAll('.faq-item.is-open').forEach(openItem => {
        if (openItem !== item) closeItem(openItem);
      });

      isOpen ? closeItem(item) : openItem(item);
    });
  });

  function openItem(el) {
    const answer = el.querySelector('.faq-answer');
    const button = el.querySelector('.faq-question');
    el.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    answer.setAttribute('aria-hidden', 'false');
    answer.style.height = answer.scrollHeight + 'px';
  }

  function closeItem(el) {
    const answer = el.querySelector('.faq-answer');
    const button = el.querySelector('.faq-question');
    el.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');
    answer.style.height = 0;
  }

  // Lista de conectores que no aportan valor al filtrado de palabras clave (es/esca).
  const STOP_WORDS = new Set([
    // Español
    'de', 'la', 'que', 'el', 'en', 'y', 'a', 'los', 'del', 'se', 'las', 'por', 'un',
    'para', 'con', 'no', 'una', 'su', 'al', 'lo', 'como', 'más', 'o', 'pero', 'sus',
    'le', 'ya', 'porque', 'esta', 'desde', 'todo', 'cuando', 'muy', 'sin', 'sobre',
    'también', 'me', 'hasta', 'donde', 'quien', 'durante', 'todos', 'uno', 'les', 'ni',
    'contra', 'otros', 'ese', 'eso', 'ante', 'ellos', 'e', 'esto', 'mí', 'antes',
    'algunos', 'qué', 'unos', 'des', 'está', 'está', 'así',
    // Catalán
    'de', 'la', 'que', 'el', 'en', 'i', 'a', 'els', 'del', 'se', 'les', 'per', 'un',
    'per', 'amb', 'no', 'una', 'el', 'al', 'com', 'més', 'o', 'però', 'els',
    'ja', 'perquè', 'aquesta', 'des', 'tot', 'quan', 'molt', 'sense', 'sobre',
    'també', 'em', 'fins', 'on', 'qui', 'durant', 'tots', 'un', 'els', 'ni',
    'contra', 'altres', 'aquell', 'això', 'abans', 'ells', 'i', 'això', 'a mi',
    'abans', 'alguns', 'què', 'uns'
  ]);

  // Elimina acentos y diacríticos además de pasar a minúsculas.
  const normalize = text =>
    (text || '')
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  // Genera un arreglo de keywords relevantes excluyendo stop words y tokens cortos.
  // Las stop words también se normalizan para que el filtro funcione sin importar acentos.
  const extractKeywords = value =>
    value
      .split(/\s+/)
      .map(normalize)
      .filter(word => word.length > 1 && !STOP_WORDS.has(word));

  // Distancia de edición (Levenshtein) entre dos cadenas.
  const levenshtein = (a, b) => {
    if (Math.abs(a.length - b.length) > 2) return 99;
    const dp = Array.from({ length: a.length + 1 }, (_, i) => [i]);
    for (let j = 1; j <= b.length; j++) dp[0][j] = j;
    for (let i = 1; i <= a.length; i++) {
      for (let j = 1; j <= b.length; j++) {
        dp[i][j] = a[i - 1] === b[j - 1]
          ? dp[i - 1][j - 1]
          : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
      }
    }
    return dp[a.length][b.length];
  };

  // Tolerancia de errores según la longitud de la keyword:
  //   ≤ 4 caracteres → sin tolerancia (evita falsos positivos en palabras cortas)
  //   5–7 caracteres → 1 error permitido
  //   ≥ 8 caracteres → 2 errores permitidos
  const maxDist = len => (len <= 4 ? 0 : len <= 7 ? 1 : 2);

  // Comprueba si una keyword encaja en alguna palabra del texto (substring o fuzzy).
  const fuzzyMatch = (keyword, textWords) => {
    if (textWords.some(w => w.includes(keyword))) return true;
    const limit = maxDist(keyword.length);
    if (limit === 0) return false;
    return textWords.some(w => {
      if (Math.abs(w.length - keyword.length) > limit) return false;
      return levenshtein(keyword, w) <= limit;
    });
  };

  const SEARCH_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 20.3 16.7 16A7.5 7.5 0 1 0 16 16.7L20.3 21 21 20.3ZM4 10.5A6.5 6.5 0 1 1 10.5 17 6.5 6.5 0 0 1 4 10.5Z"/></svg>';
  const CLEAR_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12Z"/></svg>';

  // Inicializa el buscador para cada input registrado en la sección.
  document.querySelectorAll('[data-faq-search-input]').forEach(input => {
    const sectionId = input.dataset.faqSearchInput;
    const container = document.querySelector(`.faqs[data-faq-section="${sectionId}"]`);
    const button = document.querySelector(`[data-faq-search-button="${sectionId}"]`);
    const noResults = document.querySelector(`[data-faq-no-results="${sectionId}"]`);
    if (!container) return;

    const heading =
      document.getElementById(`faq-heading-${sectionId}`) ||
      container.querySelector('.wrapper h2');

    const filterFaqs = () => {
      const keywords = extractKeywords(input.value);
      const categories = container.querySelectorAll('.faq-category');
      const hasKeywords = keywords.length > 0;

      // Por cada categoría se revisan los ítems y se actualiza su visibilidad.
      categories.forEach(category => {
        const accordion = category.querySelector('.faq-accordion');
        if (!accordion) return;

        let categoryHasMatch = false;

        accordion.querySelectorAll('.faq-item').forEach(item => {
          const question = item.querySelector('.faq-question__text');
          const textWords = normalize(question ? question.textContent : '').split(/\s+/);
          const isMatch = !hasKeywords || keywords.some(keyword => fuzzyMatch(keyword, textWords));
          item.style.display = isMatch ? '' : 'none';
          if (isMatch) categoryHasMatch = true;
        });

        const children = Array.from(accordion.children);
        let currentTitle = null;
        let currentTitleHasMatch = false;

        children.forEach(child => {
          if (child.classList.contains('faq-title')) {
            if (currentTitle) {
              currentTitle.style.display = currentTitleHasMatch ? '' : 'none';
            }
            currentTitle = child;
            currentTitleHasMatch = false;
            return;
          }

          if (child.classList.contains('faq-item') && child.style.display !== 'none') {
            currentTitleHasMatch = true;
          }
        });

        if (currentTitle) {
          currentTitle.style.display = currentTitleHasMatch ? '' : 'none';
        }

        category.style.display = categoryHasMatch ? '' : 'none';
      });

      if (noResults) {
        const anyVisible = Array.from(container.querySelectorAll('.faq-category')).some(
          cat => cat.style.display !== 'none'
        );
        noResults.hidden = !hasKeywords || anyVisible;
      }
    };

    const scrollToHeading = () => {
      if (heading) {
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const updateButtonState = () => {
      if (!button) return;
      const iconEl = button.querySelector('.faq-search__icon');
      if (!iconEl) return;
      const hasValue = input.value.trim().length > 0;
      if (hasValue) {
        iconEl.innerHTML = CLEAR_ICON;
        button.setAttribute('aria-label', 'Limpiar búsqueda');
        button.classList.add('is-clear');
      } else {
        iconEl.innerHTML = SEARCH_ICON;
        button.setAttribute('aria-label', 'Buscar FAQs');
        button.classList.remove('is-clear');
      }
    };

    const resetSearch = () => {
      input.value = '';
      filterFaqs();
      updateButtonState();
      if (noResults) noResults.hidden = true;
      input.focus();
    };

    if (button) {
      button.addEventListener('click', () => {
        if (button.classList.contains('is-clear')) {
          resetSearch();
        } else {
          filterFaqs();
          updateButtonState();
          scrollToHeading();
          input.focus();
        }
      });
    }

    input.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        filterFaqs();
        updateButtonState();
        if (heading) {
          heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });
});